import { useEffect, useState } from 'react';
import PageWrapper from '../../../../components/Display/PageWrapper';
import { useAccountContext } from '../../../../contexts/AccountContext';
import { privateFetch } from '../../../../utils/apiHelper';
import { useNavigationContext } from '../../../../contexts/NavigationContext';
import JobOfferDetail from './JobOfferDetail';

import styles from '../../../../components/Display/Wrapper.module.scss';
import JobOfferPanel from './JobOfferPanel';
import JobOfferItem from './JobOfferItem';
import DocumentPanel from '../../common/document/DocumentPanel';

function JobOfferPage({ isActive }) {
  const { accountContext } = useAccountContext();
  const { setActiveView, navigationContext } = useNavigationContext();

  const [jobOfferList, setJobOfferList] = useState([]);
  const [jobOfferDetail, setJobOfferDetail] = useState(undefined);
  const [panelIsOpen, setPanelIsOpen] = useState(false);
  const [documentManagerIsOpen, setDocumentManagerIsOpen] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(undefined);

  const [loading, setLoading] = useState(false);
  const [layout, setLayout] = useState('grid');

  useEffect(() => {
    fetchJobOfferList();
  }, []);

  const fetchJobOfferList = async () => {
    await privateFetch('GET', 'rab', `/cu/${accountContext.id}/joboffer/`).then((res) => {
      setJobOfferList(res);
    });
  };

  const handleClickJobOffer = (joboffer) => {
    setActiveView('joboffer', joboffer, 'activeJobOfferId');
  };

  const handleOpenManager = () => {
    setPanelIsOpen(true);
  };

  useEffect(() => {
    if (navigationContext.activeJobOfferId) {
      fetchJobOfferDetail();
    } else setJobOfferDetail(undefined);
  }, [navigationContext]);

  const fetchJobOfferDetail = async () => {
    await privateFetch(
      'GET',
      'rab',
      `/cu/${accountContext.id}/joboffer/${navigationContext.activeJobOfferId}/`
    ).then((res) => {
      if (res) setJobOfferDetail(res);
    });
  };

  const createJobOffer = async (jobofferForm) => {
    setLoading(true);
    await privateFetch(
      'POST',
      'rab',
      `/cu/${accountContext.id}/joboffer/`,
      "L'offre d'emploi a bien été ajouté",
      JSON.stringify(jobofferForm)
    ).then(() => {
      fetchJobOfferList();
      setPanelIsOpen(false);
      setLoading(false);
    });
  };

  const updateJobOffer = async (jobofferForm) => {
    setLoading(true);
    await privateFetch(
      'PUT',
      'rab',
      `/cu/${accountContext.id}/joboffer/${jobOfferDetail.id}/`,
      "L'offre d'emploi a bien été modifié",
      JSON.stringify(jobofferForm)
    ).then(() => {
      fetchJobOfferList();
      fetchJobOfferDetail();
      setPanelIsOpen(false);
      setLoading(false);
    });
  };

  const deleteJobOffer = async (joboffer) => {
    await privateFetch(
      'DELETE',
      'rab',
      `/cu/${accountContext.id}/joboffer/${joboffer.id}/`,
      "L'offre d'emploi a bien été supprimé"
    ).then(() => {
      fetchJobOfferList();
      setJobOfferDetail(undefined);
    });
  };

  const toggleLayout = () => {
    setLayout(layout === 'grid' ? 'list' : 'grid');
  };

  const changeLayoutAction = {
    onClick: toggleLayout,
    ariaLabel: "changer le mode d'affichage",
    icon: layout === 'grid' ? 'pi-list' : 'pi-th-large'
  };

  const newJobOfferAction = {
    onClick: handleOpenManager,
    label: "Ajouter un offre d'emploi",
    icon: 'pi-plus'
  };

  const goBackJobOfferAction = {
    onClick: handleClickJobOffer,
    label: 'Retour à la liste'
  };

  const uploadDocument = async (documentForm) => {
    setLoading(true);
    await privateFetch(
      'POST',
      'rab',
      `/cu/${accountContext.id}/joboffer/${jobOfferDetail.id}/file/`,
      'Le fichier a bien été enregistré',
      documentForm,
      false,
      true
    ).then(() => {
      fetchJobOfferDetail();
      setLoading(false);
      setDocumentManagerIsOpen(false);
    });
  };

  const updateDocument = async (documentForm) => {
    setLoading(true);
    await privateFetch(
      'PUT',
      'resources',
      `/cu/${accountContext.id}/file/${selectedDocument.id}/`,
      'Le document a bien été modifié',
      documentForm,
      false,
      true
    ).then(() => {
      fetchJobOfferDetail();
      setLoading(false);
      setDocumentManagerIsOpen(false);
    });
  };

  const handleCreateDocument = () => {
    setSelectedDocument(undefined);
    setDocumentManagerIsOpen(true);
  };

  const handleUpdateDocument = (document) => {
    setSelectedDocument(document);
    setDocumentManagerIsOpen(true);
  };

  const handleDeleteDocument = async (document) => {
    await privateFetch(
      'DELETE',
      'resources',
      `/cu/${accountContext.id}/file/${document.id}/`,
      'Le document a bien été supprimé'
    ).then(() => {
      fetchJobOfferDetail(jobOfferDetail.id);
      fetchJobOfferList();
      setSelectedDocument(undefined);
    });
  };

  return (
    <div className={`h-full w-full flex-col ${isActive ? 'flex' : 'hidden'}`}>
      <PageWrapper
        label="Offre d'emploi"
        labelAction={handleClickJobOffer}
        actions={jobOfferDetail ? [goBackJobOfferAction] : [changeLayoutAction, newJobOfferAction]}
        detail={jobOfferDetail}>
        {!jobOfferDetail ? (
          <div className={styles.pageContentContainer}>
            <div className={` ${layout === 'grid' ? styles.gridLayout : styles.listLayout}`}>
              {jobOfferList.map((joboffer, index) => (
                <JobOfferItem
                  layout={layout}
                  key={index}
                  joboffer={joboffer}
                  handleClickJobOffer={() => {
                    handleClickJobOffer(joboffer);
                  }}
                />
              ))}
            </div>
          </div>
        ) : (
          <JobOfferDetail
            joboffer={jobOfferDetail}
            handleUpdateJobOffer={handleOpenManager}
            handleDelete={deleteJobOffer}
            handleUpdateFile={handleUpdateDocument}
            handleDeleteFile={handleDeleteDocument}
            handleCreateFile={handleCreateDocument}
          />
        )}
      </PageWrapper>

      <JobOfferPanel
        isOpen={panelIsOpen}
        loading={loading}
        joboffer={jobOfferDetail}
        onUpdate={updateJobOffer}
        onClose={setPanelIsOpen}
        onCreate={createJobOffer}
      />

      <DocumentPanel
        document={selectedDocument}
        loading={loading}
        isOpen={documentManagerIsOpen}
        onClose={() => {
          setSelectedDocument(null);
          setDocumentManagerIsOpen(false);
        }}
        onCreate={uploadDocument}
        onUpdate={updateDocument}
      />
    </div>
  );
}

export default JobOfferPage;
